export default __webpack_public_path__ + "static/media/abdm-logo.48477a5f.svg";